'use client';

import { Box } from '@mui/material';
import { usePathname, redirect } from 'next/navigation';
import { type PropsWithChildren } from 'react';

import { Loader } from '@/components/layout/loading';
import { hasGlobalPermissions } from '@/configs/roles';
import { docsBaseUrl } from '@/contexts/environment';
import { useFeatureFlags, useLaunchDarkly } from '@/contexts/useFeatureFlags';
import { useSourceAccounts } from '@/contexts/useSourceAccounts';
import { useUser } from '@/contexts/useUser';

export function AuthChecker({ children }: PropsWithChildren) {
  const { user, currentProjectId } = useUser();
  const { SkipOnboarding } = useFeatureFlags();
  const pathname = usePathname();
  const { isReady } = useLaunchDarkly();
  const { sourceAccounts } = useSourceAccounts();

  const isApplicationReady =
    !!user && !!currentProjectId && !!sourceAccounts && isReady;

  if (!isApplicationReady) {
    return <LoaderComponent />;
  }

  if (SkipOnboarding && !hasGlobalPermissions(user.selectedRole)) {
    redirect(docsBaseUrl);
  }

  if (
    sourceAccounts?.length ||
    SkipOnboarding ||
    pathname.startsWith('/onboarding') ||
    pathname.startsWith('/global-settings')
  ) {
    return children;
  }

  // redirect('/global-settings/scanning-accounts');
  redirect('/onboarding');
}

const LoaderComponent = () => (
  <Box
    className='h-full'
    sx={{
      background: 'var(--mui-palette-background-pageGradient)',
    }}
  >
    <Loader />
  </Box>
);
